/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/analytics/export": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export documents analytics data
     * @description Exports aggregated documents analytics data for all customers. Returns one record per customer/targetSystem combination with aggregated metrics.
     */
    get: operations["getApiAnalyticsExport"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get All Connections
     * @description Retrieves a list of all document connections across all customers.
     */
    get: operations["getApiConnections"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{customerId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Connections for Customer
     * @description Retrieves a list of document connections for a specific customer.
     */
    get: operations["getApiConnectionsByCustomerId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{customerId}/{targetSystem}/archive": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive Connection
     * @description Archives a document connection by setting its state to archived and triggering a workflow to re-setup schedules. This operation is idempotent - archiving an already archived connection will succeed.
     */
    post: operations["postApiConnectionsByCustomerIdByTargetSystemArchive"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all customers
     * @description Retrieves a paginated list of all customers with at least one active connection.
     */
    get: operations["getApiCustomers"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get bills for a customer
     * @description Retrieves a paginated list of bills for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdBills"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific bill
     * @description Retrieves a specific bill by its ID.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download bill file
     * @description Downloads the file for a specific bill from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for bill file
     * @description Returns a pre-signed URL for direct download of the bill file from R2 storage. The URL expires after 1 hour.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger bills sync for a customer
     * @description Triggers bills synchronization workflow for all active target systems that the customer has connections for. Optionally accepts forceFullFetch parameter to trigger complete historical synchronization.
     */
    get: operations["getApiCustomersByCustomerIdBillsSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/dump": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Dump the state of the customer
     * @description Retrieves the current state of the customer for debugging purposes.
     */
    get: operations["getApiCustomersByCustomerIdDump"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/email-intake-address": {
    parameters: {
      query?: {
        /**
         * @description Set to false to return only an existing address without minting a token.
         * @default true
         */
        mint?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get the customer-facing email-intake address
     * @description Returns the rendered email-forwarding address. By default, this operation mints a missing token. Set mint=false for a read-only lookup. The raw token is never exposed.
     */
    get: operations["getApiCustomersByCustomerIdEmail-intake-address"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/emails": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List a customer’s inbound forwarded emails
     * @description Retrieves a paginated list of inbound emails for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdEmails"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/emails/{emailId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an email with its attachments and body file
     * @description Retrieves a single inbound email along with its attachments (uploads) and body file.
     */
    get: operations["getApiCustomersByCustomerIdEmailsByEmailId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get files for a customer
     * @description Retrieves a paginated list of files for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdFiles"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files/by-hash": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get bills and invoices by file hash
     * @description Finds all files matching the specified file hash and returns the bills and invoices that reference those files.
     */
    get: operations["getApiCustomersByCustomerIdFilesBy-hash"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger files sync for a customer
     * @description Manually triggers the FilesSyncWorkflow to sync files for bills and invoices without fileId.
     */
    get: operations["getApiCustomersByCustomerIdFilesSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/general-documents": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get general documents for a customer
     * @description Retrieves a paginated list of the onboarding general documents for the specified customer, newest first. The raw OCR response is never returned.
     */
    get: operations["getApiCustomersByCustomerIdGeneral-documents"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/general-documents/{documentId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a general document
     * @description Soft-deletes a general document: it disappears from the list and its file routes, and the operator and reason are recorded. The file name and hash are scrubbed and the file is deleted from R2 storage. An unknown or already deleted document is a 404.
     */
    delete: operations["deleteApiCustomersByCustomerIdGeneral-documentsByDocumentId"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/general-documents/{documentId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download general document file
     * @description Downloads the file for a specific general document from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdGeneral-documentsByDocumentIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/general-documents/{documentId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for general document file
     * @description Returns a pre-signed URL for direct download of the general document file from R2 storage. The URL expires after 1 hour. CSV bank statements are served as an attachment.
     */
    get: operations["getApiCustomersByCustomerIdGeneral-documentsByDocumentIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get invoices for a customer
     * @description Retrieves a paginated list of invoices for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdInvoices"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific invoice
     * @description Retrieves a specific invoice by its ID.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download invoice file
     * @description Downloads the file for a specific invoice from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for invoice file
     * @description Returns a pre-signed URL for direct download of the invoice file from R2 storage. The URL expires after 1 hour.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger invoices sync for a customer
     * @description Triggers invoices synchronization workflow for all active target systems that the customer has connections for. Optionally accepts forceFullFetch parameter to trigger complete historical synchronization.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/oldest-historical-start-date": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get the customer's oldest historical start date
     * @description Returns the oldest historical start date across the customer's active connections, or null when the customer has no active connections (e.g. customers using only email forwarding).
     */
    get: operations["getApiCustomersByCustomerIdOldest-historical-start-date"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/other-documents": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get other documents for a customer
     * @description Retrieves a paginated list of other documents (bookingType OTHER) for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdOther-documents"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/other-documents/{documentId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific other document
     * @description Retrieves a specific other document by its ID.
     */
    get: operations["getApiCustomersByCustomerIdOther-documentsByDocumentId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/other-documents/{documentId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download other document file
     * @description Downloads the file for a specific other document from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdOther-documentsByDocumentIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/other-documents/{documentId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for other document file
     * @description Returns a pre-signed URL for direct download of the other document file from R2 storage. The URL expires after 1 hour.
     */
    get: operations["getApiCustomersByCustomerIdOther-documentsByDocumentIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/other-documents/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger other documents sync for a customer
     * @description Triggers other documents synchronization workflow for all active target systems that the customer has connections for. Optionally accepts forceFullFetch parameter to trigger complete historical synchronization.
     */
    get: operations["getApiCustomersByCustomerIdOther-documentsSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/setup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup workflow schedules for customer
     * @description Initializes or resets workflow schedules for a customer based on all active connections. This creates recurring schedules for bills sync, invoices sync, and files sync. Use this endpoint to recover from scheduling issues or to add new workflow types for existing customers.
     */
    post: operations["postApiCustomersByCustomerIdSetup-schedule"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/uploads": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List a customer’s uploads
     * @description Retrieves a customer’s uploads. Pass `emailId` to list the uploads (attachments) of a single email.
     */
    get: operations["getApiCustomersByCustomerIdUploads"];
    put?: never;
    /**
     * Upload a document
     * @description Stores an uploaded document. The file is base64-encoded in the JSON body so it can be HMAC-signed by service callers. Without `documentType` it is a receipt upload (web/manual source): it is queued for OCR, processed by the same pipeline as email attachments and filed into the correct document bucket. With `documentType` and `uploadedByOperatorId` it is an onboarding general document: it gets a `general_documents` row, Doxis OCR runs inline (not for CSV) and its raw response is stored on that row; it never enters the receipt OCR queue. A failed OCR keeps the document without OCR data.
     */
    post: operations["postApiCustomersByCustomerIdUploads"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/target-systems": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Target Systems
     * @description Retrieves a list of all supported accounting target systems
     */
    get: operations["getApiTarget-systems"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/target-systems/{targetSystemId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Target System
     * @description Retrieves details of a specific target system by ID
     */
    get: operations["getApiTarget-systemsByTargetSystemId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/redirect/{customerId}/{targetSystem}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations["getRedirectByCustomerIdByTargetSystem"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** @description Details of an HTTP 400 error. */
    ApiErrorDetails400: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Bad Request
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 400
       * @constant
       */
      statusCode: 400;
    };
    /** @description Details of an HTTP 401 error. */
    ApiErrorDetails401: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Unauthorized
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 401
       * @constant
       */
      statusCode: 401;
    };
    /** @description Details of an HTTP 404 error. */
    ApiErrorDetails404: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Not Found
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 404
       * @constant
       */
      statusCode: 404;
    };
    /** @description Details of an HTTP 500 error. */
    ApiErrorDetails500: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example InternalServerError
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Internal Server Error
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 500
       * @constant
       */
      statusCode: 500;
    };
    Bill: {
      billDate: string | null;
      billNumber: string | null;
      createdAt: string;
      currency: string;
      /** @description File metadata if available */
      file: {
        contentType: string;
        createdAt: string;
        fileHash: string;
        fileName: string;
        fileSize: number;
        id: string;
        updatedAt: string;
      } | null;
      id: string;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    BillByHash: {
      billDate: string | null;
      billNumber: string | null;
      createdAt: string;
      currency: string;
      id: string;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    Connection: {
      /** @description ISO timestamp when the connection was archived */
      archivedAt: string | null;
      /**
       * @description Count of consecutive sync runs that hit a 401/403. Reset to 0 on any successful sync. The connection is only marked errored once this reaches AUTH_ERROR_THRESHOLD.
       * @default 0
       */
      consecutiveAuthErrors: number;
      /** @description ISO timestamp when the connection was created */
      createdAt: string;
      /** @description The customer identifier */
      customerId: string;
      /** @description HTTP status code (401 or 403) */
      errorCode: number | null;
      /** @description ISO timestamp when auth error occurred */
      erroredAt: string | null;
      /** @description ISO date for historical data retrieval start */
      historicalStartDate: string | null;
      /** @description ISO timestamp when bills were last inserted */
      lastBillsAddedAt: string | null;
      /** @description ISO timestamp of the last successful bills sync workflow run */
      lastBillsSyncedAt: string | null;
      /** @description ISO timestamp when invoices were last inserted */
      lastInvoicesAddedAt: string | null;
      /** @description ISO timestamp of the last successful invoices sync workflow run */
      lastInvoicesSyncedAt: string | null;
      /**
       * @description ISO timestamp when other-documents were last inserted
       * @default null
       */
      lastOtherDocumentsAddedAt: string | null;
      /**
       * @description ISO timestamp of the last successful other-documents sync workflow run
       * @default null
       */
      lastOtherDocumentsSyncedAt: string | null;
      /** @description The reference identifier for the connection */
      reference: string;
      /**
       * @description The current state of the connection
       * @enum {string}
       */
      state: "pending" | "active" | "errored" | "archived";
      /** @description The target system (e.g., MAESN, DATEV) */
      targetSystem: string;
      /** @description ISO timestamp when the connection was last updated */
      updatedAt: string;
    };
    ConnectionsAnalyticsRecord: {
      /** @description ISO timestamp when archived (empty if null) */
      archivedAt: string;
      /** @description ISO timestamp when created */
      createdAt: string;
      /** @description Customer UUID */
      customerId: string;
      /** @description HTTP status code for auth error (empty if null) */
      errorCode: string;
      /** @description ISO timestamp when auth error occurred (empty if null) */
      erroredAt: string;
      /** @description ISO date for historical data retrieval start (empty if null) */
      historicalStartDate: string;
      /** @description ISO timestamp when bills were last inserted (empty if null) */
      lastBillsAddedAt: string;
      /** @description ISO timestamp of last successful bills sync workflow run (empty if null) */
      lastBillsSyncedAt: string;
      /** @description ISO timestamp when invoices were last inserted (empty if null) */
      lastInvoicesAddedAt: string;
      /** @description ISO timestamp of last successful invoices sync workflow run (empty if null) */
      lastInvoicesSyncedAt: string;
      /** @description Connection state: pending, active, errored */
      state: string;
      /** @description Target system identifier (e.g., MAESN, LEXOFFICE) */
      targetSystem: string;
      /** @description ISO timestamp when last updated */
      updatedAt: string;
    };
    Customer: {
      /**
       * Format: uuid
       * @description Unique identifier for the customer
       * @example 945163ef-cbb2-467e-a74d-b8b03d065aa0
       */
      customerId: string;
      /**
       * @description The oldest historical start date across all active connections for this customer (defaults to today if none set)
       * @example 2023-01-01
       */
      oldestHistoricalStartDate: string;
    };
    CustomerOldestHistoricalStartDate: {
      /**
       * Format: uuid
       * @description Unique identifier for the customer
       * @example 945163ef-cbb2-467e-a74d-b8b03d065aa0
       */
      customerId: string;
      /**
       * @description The oldest historical start date across all active connections for this customer, or null when the customer has no active connections
       * @example 2023-01-01
       */
      oldestHistoricalStartDate: string | null;
    };
    DocumentsAnalyticsExportResponse: {
      connections: components["schemas"]["ConnectionsAnalyticsRecord"][];
      /** @description Total number of customers processed */
      customerCount: number;
      /** @description Number of customers that failed to process */
      failedCount: number;
      records: components["schemas"]["DocumentsAnalyticsRecord"][];
    };
    DocumentsAnalyticsRecord: {
      /** @description Total count of bills for this customer/targetSystem */
      billsCount: number;
      /** @description Count of bills with fileId not null */
      billsWithFiles: number;
      /** @description Customer UUID */
      customerId: string;
      /** @description Total count of files (across all targetSystems) */
      filesCount: number;
      /** @description Total count of invoices for this customer/targetSystem */
      invoicesCount: number;
      /** @description Count of invoices with fileId not null */
      invoicesWithFiles: number;
      /** @description Target system identifier (e.g., MAESN, LEXOFFICE) */
      targetSystem: string;
    };
    DumpData: {
      /** @description Durable Object storage information */
      storage: components["schemas"]["DumpStorageInfo"];
      tables: components["schemas"]["DumpTableInfo"][];
    };
    DumpStorageInfo: {
      /** @description ISO 8601 timestamp of next scheduled alarm, or null if no alarm set */
      nextAlarm: string | null;
      /** @description Current workflow schedules stored in Durable Object */
      workflowSchedule: components["schemas"]["WorkflowScheduleInfo"][] | null;
    };
    DumpTableInfo: {
      data: unknown[];
      name: string;
      schema: string;
    };
    Email: {
      /** @enum {string} */
      attachmentStatus: "has_valid" | "unsupported_only" | "none";
      bodyFileId: string | null;
      createdAt: string;
      fromAddress: string;
      id: string;
      messageId: string;
      receivedAt: string;
      subject: string | null;
      toAddress: string;
      updatedAt: string;
    };
    EmailIntakeAddress: {
      /** Format: email */
      address: string;
      /** Format: uuid */
      customerId: string;
    };
    EmailWithAttachments: {
      attachments: components["schemas"]["Upload"][];
      bodyFile: components["schemas"]["File"] | null;
    } & components["schemas"]["Email"];
    ErrorResponse400: {
      error: components["schemas"]["ApiErrorDetails400"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse401: {
      error: components["schemas"]["ApiErrorDetails401"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse404: {
      error: components["schemas"]["ApiErrorDetails404"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse500: {
      error: components["schemas"]["ApiErrorDetails500"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    File: {
      contentType: string;
      createdAt: string;
      fileHash: string;
      fileName: string;
      fileSize: number;
      id: string;
      r2Key: string;
      updatedAt: string;
    };
    FileHashReferencesResponse: {
      bills: components["schemas"]["BillByHash"][];
      invoices: components["schemas"]["InvoiceByHash"][];
      otherDocuments: components["schemas"]["OtherDocumentByHash"][];
    };
    FileUrlResponse: {
      /** @description MIME type of the file */
      contentType: string;
      /** @description URL expiry time in seconds */
      expiresIn: number;
      /**
       * Format: uri
       * @description Pre-signed URL for direct file download
       */
      url: string;
    };
    GeneralDocument: {
      contentType: string;
      createdAt: string;
      /** @enum {string} */
      documentType:
        | "personalausweis"
        | "vollmacht"
        | "partnervollmacht"
        | "steuerunterlagen"
        | "gewerbeanmeldung"
        | "steuernummern"
        | "kontoauszuege"
        | "angebot"
        | "preisverzeichnis";
      fileId: string;
      fileName: string;
      /** @description Whether the raw OCR response is stored for this document. */
      hasOcrData: boolean;
      id: string;
      uploadedByOperatorId: string;
    };
    Invoice: {
      createdAt: string;
      currency: string;
      /** @description File metadata if available */
      file: {
        contentType: string;
        createdAt: string;
        fileHash: string;
        fileName: string;
        fileSize: number;
        id: string;
        updatedAt: string;
      } | null;
      id: string;
      invoiceDate: string | null;
      invoiceNumber: string | null;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    InvoiceByHash: {
      createdAt: string;
      currency: string;
      id: string;
      invoiceDate: string | null;
      invoiceNumber: string | null;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    OtherDocument: {
      createdAt: string;
      currency: string | null;
      documentDate: string | null;
      documentNumber: string | null;
      /** @description File metadata if available */
      file: {
        contentType: string;
        createdAt: string;
        fileHash: string;
        fileName: string;
        fileSize: number;
        id: string;
        updatedAt: string;
      } | null;
      id: string;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    OtherDocumentByHash: {
      createdAt: string;
      currency: string | null;
      documentDate: string | null;
      documentNumber: string | null;
      id: string;
      name: string | null;
      /** @enum {string} */
      provider: "maesn" | "doxis";
      targetSystem: string | null;
      totalAmount: number | null;
      updatedAt: string;
    };
    /** @description Standard pagination information */
    PaginationInfo: {
      /**
       * @description Maximum number of items returned per page
       * @example 10
       */
      limit: number;
      /**
       * @description Number of items skipped from the beginning
       * @example 0
       */
      offset: number;
      /**
       * @description Total number of items available
       * @example 100
       */
      total: number;
    };
    TargetSystem: {
      /** @description API capabilities supported by this target system */
      capabilities: components["schemas"]["TargetSystemCapabilities"];
      /**
       * @description Unique identifier for the target system
       * @example lexware-office
       */
      id: string;
      /**
       * @description Whether this target system is in beta
       * @example true
       */
      isBeta?: boolean;
      /**
       * @description Whether this target system is not yet connectable and should be surfaced as "coming soon"
       * @example true
       */
      isComingSoon?: boolean;
      /** @description Locale-specific content for the target system */
      locales: {
        /** @description German locale content */
        de: {
          /**
           * Format: uri
           * @description Optional URL to localized help article for the target system
           * @example https://intercom-help.eu/smarta-steuern/en/articles/419759-how-to-connect-your-lexware-office-account-with-your-smarta-profile
           */
          helpUrl?: string;
          /**
           * @description Localized display name of the target system
           * @example Lexware Office XL
           */
          name: string;
        };
        /** @description English locale content */
        en: {
          /**
           * Format: uri
           * @description Optional URL to localized help article for the target system
           * @example https://intercom-help.eu/smarta-steuern/en/articles/419759-how-to-connect-your-lexware-office-account-with-your-smarta-profile
           */
          helpUrl?: string;
          /**
           * @description Localized display name of the target system
           * @example Lexware Office XL
           */
          name: string;
        };
      };
      /**
       * Format: uri
       * @description URL to the target system logo
       * @example https://cdn.smarta.tax/images/target-systems/lexware-office-logo.svg
       */
      logoUrl: string;
    };
    TargetSystemCapabilities: {
      /** @description Capabilities of the /accounting/bills endpoint. */
      bills: {
        /**
         * @description Maesn filter used to bound the bills query. buchhaltungsbutler-api rejects lastModifiedAt and uses billDateFrom instead.
         * @example lastModifiedAt
         * @enum {string}
         */
        filter: "lastModifiedAt" | "billDateFrom";
        /**
         * @description Supported order field. Omit when the provider rejects ordering (e.g. sevdesk returns 400).
         * @example updatedDate
         * @enum {string}
         */
        orderField?: "billDate" | "billNumber" | "createdDate" | "updatedDate";
      };
      /** @description Capabilities of the /accounting/bookingProposals endpoint. Absent when the provider serves no booking types and the endpoint must not be called. */
      bookingProposals?: {
        /**
         * @description Maesn filter used to bound the booking-proposals query.
         * @example lastModifiedAt
         * @constant
         */
        filter: "lastModifiedAt";
        /**
         * @description Supported order field. Omit when the provider rejects ordering (e.g. sevdesk returns 400).
         * @example updatedDate
         * @enum {string}
         */
        orderField?: "createdDate" | "updatedDate";
        /**
         * @description Booking types the provider serves. INVOICE feeds the invoices sync, OTHER feeds the other-documents sync.
         * @example [
         *       "INVOICE"
         *     ]
         */
        types: ("INVOICE" | "OTHER")[];
      };
      /** @description Capabilities of the /accounting/invoices endpoint. */
      invoices: {
        /**
         * @description Maesn filter used to bound the invoices query. buchhaltungsbutler-api rejects lastModifiedAt and has no server-side substitute, so it uses none.
         * @example lastModifiedAt
         * @enum {string}
         */
        filter: "lastModifiedAt" | "none";
        /**
         * @description Supported order field. Omit when the provider rejects ordering (e.g. sevdesk returns 400). buchhaltungsbutler-api only accepts invoiceDate, invoiceNumber and name.
         * @example updatedDate
         * @enum {string}
         */
        orderField?: "invoiceDate" | "createdDate" | "updatedDate";
      };
    };
    Upload: {
      createdAt: string;
      emailId: string | null;
      error: string | null;
      fileId: string;
      id: string;
      /** @enum {string} */
      ocrStatus: "pending" | "processing" | "done" | "failed" | "skipped";
      /** @enum {string} */
      source: "email" | "web" | "mobile";
      updatedAt: string;
    };
    WorkflowScheduleInfo: {
      /** @description Interval between executions in milliseconds */
      intervalMs: number;
      /** @description Unix timestamp of last execution */
      lastExecutionTime?: number;
      /** @description Unix timestamp of next execution */
      nextExecutionTime: number;
      options: {
        params: {
          /** @description Customer UUID */
          customerId: string;
          /** @description Target system (e.g., lexware-office). Not present for filesSync. */
          targetSystem?: string;
        };
      }[];
      /** @description Schedule status (active, paused, failed) */
      status: string;
      /** @description Workflow type (e.g., billsSync, invoicesSync, filesSync) */
      type: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type ApiErrorDetails400 = components["schemas"]["ApiErrorDetails400"];
export type ApiErrorDetails401 = components["schemas"]["ApiErrorDetails401"];
export type ApiErrorDetails404 = components["schemas"]["ApiErrorDetails404"];
export type ApiErrorDetails500 = components["schemas"]["ApiErrorDetails500"];
export type Bill = components["schemas"]["Bill"];
export type BillByHash = components["schemas"]["BillByHash"];
export type Connection = components["schemas"]["Connection"];
export type ConnectionsAnalyticsRecord =
  components["schemas"]["ConnectionsAnalyticsRecord"];
export type Customer = components["schemas"]["Customer"];
export type CustomerOldestHistoricalStartDate =
  components["schemas"]["CustomerOldestHistoricalStartDate"];
export type DocumentsAnalyticsExportResponse =
  components["schemas"]["DocumentsAnalyticsExportResponse"];
export type DocumentsAnalyticsRecord =
  components["schemas"]["DocumentsAnalyticsRecord"];
export type DumpData = components["schemas"]["DumpData"];
export type DumpStorageInfo = components["schemas"]["DumpStorageInfo"];
export type DumpTableInfo = components["schemas"]["DumpTableInfo"];
export type Email = components["schemas"]["Email"];
export type EmailIntakeAddress = components["schemas"]["EmailIntakeAddress"];
export type EmailWithAttachments =
  components["schemas"]["EmailWithAttachments"];
export type ErrorResponse400 = components["schemas"]["ErrorResponse400"];
export type ErrorResponse401 = components["schemas"]["ErrorResponse401"];
export type ErrorResponse404 = components["schemas"]["ErrorResponse404"];
export type ErrorResponse500 = components["schemas"]["ErrorResponse500"];
export type File = components["schemas"]["File"];
export type FileHashReferencesResponse =
  components["schemas"]["FileHashReferencesResponse"];
export type FileUrlResponse = components["schemas"]["FileUrlResponse"];
export type GeneralDocument = components["schemas"]["GeneralDocument"];
export type Invoice = components["schemas"]["Invoice"];
export type InvoiceByHash = components["schemas"]["InvoiceByHash"];
export type OtherDocument = components["schemas"]["OtherDocument"];
export type OtherDocumentByHash = components["schemas"]["OtherDocumentByHash"];
export type PaginationInfo = components["schemas"]["PaginationInfo"];
export type TargetSystem = components["schemas"]["TargetSystem"];
export type TargetSystemCapabilities =
  components["schemas"]["TargetSystemCapabilities"];
export type Upload = components["schemas"]["Upload"];
export type WorkflowScheduleInfo =
  components["schemas"]["WorkflowScheduleInfo"];
export type $defs = Record<string, never>;
export interface operations {
  getApiAnalyticsExport: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully exported analytics data. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["DocumentsAnalyticsExportResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiConnections: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of all connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiConnectionsByCustomerId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of connections for the customer. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiConnectionsByCustomerIdByTargetSystemArchive: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        targetSystem: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully started the connection archival workflow. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description The customer ID */
              customerId: string;
              /**
               * @description The status of the operation
               * @constant
               */
              status: "started";
              /** @description The target system */
              targetSystem: string;
              /** @description The ID of the archival workflow */
              workflowId: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Connection not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomers: {
    parameters: {
      query?: {
        limit?: number;
        page?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of customers. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Customer"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBills: {
    parameters: {
      query?: {
        billDateFrom?: string;
        hasFile?: boolean;
        limit?: number;
        offset?: number;
        skipNoSourceFile?: boolean;
        sortBy?: "billDate" | "createdAt" | "updatedAt";
        sortOrder?: "asc" | "desc";
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved bills. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Bill"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsByBillId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the bill. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Bill"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsByBillIdFile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the bill file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdBillsByBillIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsSync: {
    parameters: {
      query?: {
        forceFullFetch?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued bills sync workflow instances for all active connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Target systems that were synced */
              targetSystems: string[];
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDump: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the customer state. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["DumpData"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdEmail-intake-address": {
    parameters: {
      query?: {
        /**
         * @description Set to false to return only an existing address without minting a token.
         * @default true
         */
        mint?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The rendered intake address. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["EmailIntakeAddress"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Customer not found in smarta-accounts. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdEmails: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved emails. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Email"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdEmailsByEmailId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        emailId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the email. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["EmailWithAttachments"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Email not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdFiles: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved files. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["File"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdFilesBy-hash": {
    parameters: {
      query: {
        file_hash: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved bills and invoices for the file hash. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileHashReferencesResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid file hash parameter. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdFilesSync: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued files sync workflow. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description The workflow instance ID */
              workflowId: string;
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdGeneral-documents": {
    parameters: {
      query?: {
        documentType?:
          | "personalausweis"
          | "vollmacht"
          | "partnervollmacht"
          | "steuerunterlagen"
          | "gewerbeanmeldung"
          | "steuernummern"
          | "kontoauszuege"
          | "angebot"
          | "preisverzeichnis";
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved general documents. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["GeneralDocument"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "deleteApiCustomersByCustomerIdGeneral-documentsByDocumentId": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": {
          /** @description smarta-accounts operator id of the operator deleting the document. */
          deletedByOperatorId: string;
          /**
           * @description Why the operator deletes the document.
           * @enum {string}
           */
          deletionReason:
            | "wrong_field_or_lead"
            | "wrong_or_duplicate_file"
            | "customer_request";
        };
      };
    };
    responses: {
      /** @description Document deleted. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Document not found, or already deleted. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdGeneral-documentsByDocumentIdFile": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the document file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdGeneral-documentsByDocumentIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoices: {
    parameters: {
      query?: {
        hasFile?: boolean;
        invoiceDateFrom?: string;
        limit?: number;
        offset?: number;
        skipNoSourceFile?: boolean;
        sortBy?: "invoiceDate" | "createdAt" | "updatedAt";
        sortOrder?: "asc" | "desc";
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved invoices. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Invoice"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesByInvoiceId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the invoice. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Invoice"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the invoice file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdInvoicesByInvoiceIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesSync: {
    parameters: {
      query?: {
        forceFullFetch?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued invoices sync workflow instances for all active connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Target systems that were synced */
              targetSystems: string[];
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOldest-historical-start-date": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The customer's oldest historical start date. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["CustomerOldestHistoricalStartDate"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOther-documents": {
    parameters: {
      query?: {
        documentDateFrom?: string;
        hasFile?: boolean;
        limit?: number;
        offset?: number;
        skipNoSourceFile?: boolean;
        sortBy?: "documentDate" | "createdAt" | "updatedAt";
        sortOrder?: "asc" | "desc";
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved other documents. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["OtherDocument"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOther-documentsByDocumentId": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the document. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["OtherDocument"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOther-documentsByDocumentIdFile": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the document file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOther-documentsByDocumentIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdOther-documentsSync": {
    parameters: {
      query?: {
        forceFullFetch?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued documents sync workflow instances for all active connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Target systems that were synced */
              targetSystems: string[];
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "postApiCustomersByCustomerIdSetup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully set up workflow schedules. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Detailed message about the operation result */
              message: string;
              /**
               * @description Status of the setup operation
               * @enum {string}
               */
              status: "completed" | "error";
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdUploads: {
    parameters: {
      query?: {
        emailId?: string;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved uploads. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Upload"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdUploads: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": {
          /** @description Base64-encoded file bytes (max 15 MB decoded). */
          contentBase64: string;
          /**
           * @description One of the supported document content types. `text/csv` is accepted only for a general document of type `kontoauszuege`.
           * @enum {string}
           */
          contentType:
            | "application/pdf"
            | "image/jpeg"
            | "image/png"
            | "text/csv";
          /**
           * @description Onboarding document type. Set together with `uploadedByOperatorId` to store a general document instead of a receipt upload.
           * @enum {string}
           */
          documentType?:
            | "personalausweis"
            | "vollmacht"
            | "partnervollmacht"
            | "steuerunterlagen"
            | "gewerbeanmeldung"
            | "steuernummern"
            | "kontoauszuege"
            | "angebot"
            | "preisverzeichnis";
          /** @example receipt.pdf */
          fileName: string;
          /** @description smarta-accounts operator id of the uploader. Set by the gateway from the session, together with `documentType`. */
          uploadedByOperatorId?: string;
        };
      };
    };
    responses: {
      /** @description Document stored. Exactly one of `uploadId` (receipt upload) or `generalDocumentId` (general document) is set. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Id of the stored file. */
              fileId: string;
              /** @description Id of the created general document. Set for general document uploads only. */
              generalDocumentId?: string;
              /** @description Id of the created receipt upload (OCR is queued). Set for receipt uploads only. */
              uploadId?: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiTarget-systems": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of target systems */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["TargetSystem"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiTarget-systemsByTargetSystemId": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        targetSystemId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the target system */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["TargetSystem"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Target system not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getRedirectByCustomerIdByTargetSystem: {
    parameters: {
      query: {
        historicalStartDate: string;
      };
      header?: never;
      path: {
        customerId: string;
        targetSystem: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: never;
  };
}
export enum ApiPaths {
  getRedirectByCustomerIdByTargetSystem = "/redirect/{customerId}/{targetSystem}",
  getApiAnalyticsExport = "/api/analytics/export",
  getApiConnections = "/api/connections",
  getApiConnectionsByCustomerId = "/api/connections/{customerId}",
  postApiConnectionsByCustomerIdByTargetSystemArchive = "/api/connections/{customerId}/{targetSystem}/archive",
  getApiCustomers = "/api/customers",
  getApiCustomersByCustomerIdBills = "/api/customers/{customerId}/bills",
  getApiCustomersByCustomerIdBillsSync = "/api/customers/{customerId}/bills/sync",
  getApiCustomersByCustomerIdBillsByBillId = "/api/customers/{customerId}/bills/{billId}",
  getApiCustomersByCustomerIdBillsByBillIdFile = "/api/customers/{customerId}/bills/{billId}/file",
  getApiCustomersByCustomerIdBillsByBillIdFile_url = "/api/customers/{customerId}/bills/{billId}/file-url",
  getApiCustomersByCustomerIdInvoices = "/api/customers/{customerId}/invoices",
  getApiCustomersByCustomerIdInvoicesSync = "/api/customers/{customerId}/invoices/sync",
  getApiCustomersByCustomerIdInvoicesByInvoiceId = "/api/customers/{customerId}/invoices/{invoiceId}",
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile = "/api/customers/{customerId}/invoices/{invoiceId}/file",
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile_url = "/api/customers/{customerId}/invoices/{invoiceId}/file-url",
  getApiCustomersByCustomerIdOther_documents = "/api/customers/{customerId}/other-documents",
  getApiCustomersByCustomerIdOther_documentsSync = "/api/customers/{customerId}/other-documents/sync",
  getApiCustomersByCustomerIdOther_documentsByDocumentId = "/api/customers/{customerId}/other-documents/{documentId}",
  getApiCustomersByCustomerIdOther_documentsByDocumentIdFile = "/api/customers/{customerId}/other-documents/{documentId}/file",
  getApiCustomersByCustomerIdOther_documentsByDocumentIdFile_url = "/api/customers/{customerId}/other-documents/{documentId}/file-url",
  getApiCustomersByCustomerIdFiles = "/api/customers/{customerId}/files",
  getApiCustomersByCustomerIdFilesSync = "/api/customers/{customerId}/files/sync",
  getApiCustomersByCustomerIdFilesBy_hash = "/api/customers/{customerId}/files/by-hash",
  getApiCustomersByCustomerIdGeneral_documents = "/api/customers/{customerId}/general-documents",
  getApiCustomersByCustomerIdGeneral_documentsByDocumentIdFile = "/api/customers/{customerId}/general-documents/{documentId}/file",
  getApiCustomersByCustomerIdGeneral_documentsByDocumentIdFile_url = "/api/customers/{customerId}/general-documents/{documentId}/file-url",
  deleteApiCustomersByCustomerIdGeneral_documentsByDocumentId = "/api/customers/{customerId}/general-documents/{documentId}",
  getApiCustomersByCustomerIdEmails = "/api/customers/{customerId}/emails",
  getApiCustomersByCustomerIdEmailsByEmailId = "/api/customers/{customerId}/emails/{emailId}",
  getApiCustomersByCustomerIdUploads = "/api/customers/{customerId}/uploads",
  postApiCustomersByCustomerIdUploads = "/api/customers/{customerId}/uploads",
  getApiCustomersByCustomerIdDump = "/api/customers/{customerId}/dump",
  getApiCustomersByCustomerIdEmail_intake_address = "/api/customers/{customerId}/email-intake-address",
  getApiCustomersByCustomerIdOldest_historical_start_date = "/api/customers/{customerId}/oldest-historical-start-date",
  postApiCustomersByCustomerIdSetup_schedule = "/api/customers/{customerId}/setup-schedule",
  getApiTarget_systems = "/api/target-systems",
  getApiTarget_systemsByTargetSystemId = "/api/target-systems/{targetSystemId}",
}
